module.exports = __webpack_public_path__ + "static/img/landing-min.210bcca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/min/landing-min.jpg
// module id = REBe
// module chunks = 1